<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("seattype") }}</div>
        <div class="section-subTitle my-2">{{ $tc("listOfAddSeatTypes") }}</div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="dropdown-curve-container">
        <div class="d-flex align-items-center w-25">
          <multiselect
            :group-select="false"
            select-label="Select"
            placeholder="Cinema"
            label="cine_name"
            :options="cinemasName"
            deselect-label="Remove"
            track-by="cine_id"
            @select="onSelectCinema($event)"
            @remove="onRemoveCinema($event)"
            v-model="selectedCineIdObj"
          ></multiselect>
        </div>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $tc("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <b-button variant="default" @click="getSeatTypes('N')" class="btn-blue">{{
          $t("fetch")
        }}</b-button>
        <button
          v-if="GridViewFlag"
          class="btnj btn-gridView mr-3"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          v-if="GridViewFlag"
          class="btnj btn-listView"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <div
            v-if="SeatTypesList.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getSeatTypes('Y')"
              title="Download as Excel"
              download
              style="cursor: pointer;"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-4">{{ $tc("status", 2) }}</span>
          </th>
          <th style="width: 160px">
            <img
              v-if="this.columnName != 'sst_seat_type'"
              @click="onSortValue('sst_seat_type', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('sst_seat_type', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('sst_seat_type', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("seattype") }}
          </th>
          <th class="text-center" style="width: 160px">
            {{ $tc("screen", 1) }}
          </th>
          <th class="text-center" style="width: 160px">
            {{ $tc("Seats", 1) }}
          </th>
          <th class="text-left pl-2">
            <img
              v-if="this.columnName != 'cine_name'"
              @click="onSortValue('cine_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('cine_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('cine_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />{{ $tc("cinema", 1) }}
          </th>
        </tr>
      </thead>
      <tbody v-if="SeatTypesList.length > 0">
        <tr
          v-for="(SeatTypes, SeatTypesIndex) in SeatTypesList"
          :key="SeatTypesIndex"
        >
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="
                  SeatTypes.sst_is_active === 'Y' ? 'active' : 'inactive'
                "
              />

              <span
                v-if="$can('update', 'Seat Type')"
                class="edit-icon ml-4 blue-icon"
                @click="goToRoute('/cinema-manager/edit-seat-type', SeatTypes)"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </span>
              <span
                class="view-icon ml-2 blue-icon"
                @click="goToRoute('/cinema-manager/view-seat-type', SeatTypes)"
                style="cursor: pointer"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <i class="icon-eye icon blue-icon"></i>
              </span>
            </div>
          </td>

          <td>{{ SeatTypes.sst_seat_type }}</td>
          <td class="text-center">{{ SeatTypes.screen_name }}</td>
          <td class="text-center">{{ SeatTypes.sst_no_of_seats }}</td>
          <td class="text-left pl-2">{{ SeatTypes.cine_name }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="4">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(SeatTypes, SeatTypesIndex) in SeatTypesList"
        :key="SeatTypesIndex"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ SeatTypes.sst_seat_type }}</h6>
            <div>
              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  v-if="$can('update', 'Seat Type')"
                  @click="
                    goToRoute('/cinema-manager/edit-seat-type', SeatTypes)
                  "
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="
                    goToRoute('/cinema-manager/view-seat-type', SeatTypes)
                  "
                >
                  <span class="icon-eye"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <div class="col-4">
                <b-form-checkbox
                  disabled
                  v-model="SeatTypes.sst_is_active"
                  unchecked-value="N"
                  value="Y"
                  name="check-button"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import SeatService from "@/services/SeatService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      cinema_id: null,
      // Saif
      SeatTypesList: [],
      // Saif
      viewingnumbers: [],

      gridView: false,
      listView: true,

      debounce: null,
      searchValue: "",

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
      cinemasName: [],
      selectedCineId: "",
      selectedCineIdObj: "",
      cinema_name: "",
      cinema_address: ""
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    const obj = this.secureStore.get("USINFO").cinema_id;
    this.getCinemasList(obj);
    // this.getSeatTypes();
    this.getviewingnumber();
  },
  mounted() {},
  methods: {
    onSelectCinema(event) {
     
      this.selectedCineId = event.cine_id;
      this.cinema_name = event.cine_name;
      this.cinema_address = event.cine_address
      // this.getSeatTypes();
    },
    // onFetch() {
    //   this.getSeatTypes();
    // },
    onRemoveCinema(event) {
      this.selectedCineId = "";
      
      // this.getSeatTypes();
    },
    getCinemasList: function (cine_id) {
      this.cinemasName = [];
      let loader = this.$loading.show();
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemasName = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 100);
        });
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getSeatTypes();
      } else {
        this.currentPage = event;
        this.getSeatTypes();
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getSeatTypes();
    },
    // Saif
    getSeatTypes(isExcel  ='N') {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        cinema_id: this.selectedCineId,
        searchValue: this.searchValue,
        isExcel:isExcel,
        
        cinema_name: this.cinema_name,
        cinema_address: this.cinema_address
      };
      console.log("payload=>", payload);
      let loader = this.$loading.show();

      SeatService.GetSeatTypes(payload)
        .then((response) => {
          const { data } = response;
         // console.log("data",data);
          if (data && data.status) {
            this.SeatTypesList = data.Records;
            if (isExcel == 'Y' && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.SeatTypesList = [];
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError) //message
        .finally(() => {
          setTimeout(() => loader.hide(), 100);
        });
    },
    goToRoute: function (path, { sst_id }) {
      this.$router.push({
        path: path,
        query: {
          id: sst_id,
        },
      });
    },
    // Saif

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/SeatTypeComponents/seatType.vue